// extracted by mini-css-extract-plugin
export default {"socials":"socials__socials__xO2kA","social":"socials__social__uuDX4","icon":"socials__icon__a3pDn","navOpen":"socials__navOpen__jdpFQ"};